import { render, staticRenderFns } from "./FromOtherSchoolQuestion.vue?vue&type=template&id=30207e28&scoped=true"
import script from "./FromOtherSchoolQuestion.vue?vue&type=script&lang=js"
export * from "./FromOtherSchoolQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30207e28",
  null
  
)

export default component.exports